module.exports = __webpack_public_path__ + "img/bermuda.20002c96.png";